<template>
  <BaseTooltip :text="text" :oben="oben" :fixiert="fixiert" :wrapper-class="wrapperClass">
    <button
        type="button"
        class="inline-flex shrink-0 rounded-full focus:outline-none
               focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-indigo-400"
        :class="tonKlassen"
        :aria-label="beschriftung"
    >
      <InformationCircleIcon class="w-4 h-4" aria-hidden="true" />
    </button>
  </BaseTooltip>
</template>

<script>
/**
 * Ein Info-Icon, das eine Erklaerung traegt.
 *
 * ACHTUNG, der Grund fuer den <button> und warum ein blankes <svg> hier
 * NICHT genuegt: BaseTooltip oeffnet auf mouseenter UND focusin. Ein <svg>
 * ist nicht fokussierbar -- ein Tooltip daran ist damit reine Mausfunktion.
 * Solange die Erklaerungen als Absaetze im Dokument standen, war das
 * folgenlos; seit sie an Icons haengen, waeren sie fuer Tastatur- und
 * Screenreader-Bedienung ERSATZLOS verschwunden. Ein <button> ist von Haus
 * aus fokussierbar, wird angesagt und oeffnet den Tooltip auf einem
 * Touchgeraet per Tipp, wo es gar kein hover gibt.
 *
 * aria-label statt aria-describedby: der Tooltip-Knoten existiert im DOM
 * erst, waehrend er offen ist -- eine Referenz darauf zeigte die meiste Zeit
 * ins Leere.
 *
 * Der Ton ist eine Aufzaehlung und keine freie Klasse, damit ein Icon in
 * einem Warnkasten nicht per Zufall grau bleibt.
 */
import BaseTooltip from "./BaseTooltip.vue";
import { InformationCircleIcon } from "@heroicons/vue/24/outline";

const TOENE = {
  grau: "text-gray-400 hover:text-gray-600",
  amber: "text-amber-600 hover:text-amber-800",
  rot: "text-red-600 hover:text-red-800",
};

export default {
  components: { BaseTooltip, InformationCircleIcon },
  props: {
    text: { type: String, required: true },
    /** Woran die Erklaerung haengt -- wird zur Ansage fuer Screenreader. */
    label: { type: String, required: true },
    ton: {
      type: String,
      default: "grau",
      validator: (w) => Object.keys(TOENE).includes(w),
    },
    oben: { type: Boolean, default: true },
    /** Am Viewport statt am Ausloeser -- noetig in Scroll-Containern. */
    fixiert: { type: Boolean, default: false },
    wrapperClass: { type: String, default: "" },
  },
  computed: {
    tonKlassen() {
      return TOENE[this.ton] || TOENE.grau;
    },
    beschriftung() {
      return "Erklärung: " + this.label;
    },
  },
};
</script>
